import React, { useState } from 'react'
import { useTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap"
import Message from '../../../../Common/Message';
import { useBoolean } from '@fluentui/react-hooks';

import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { saveMessageComment } from "../../../../../services/sBook/message-log.service"
import CTextAreaSimple from '../../../../Common/CTextAreaSimple';
import { _global_buttonStyles } from '../../../../../common/ObjectStructures/Trasnversal';


function SidePanelNewCommentEvent(props) {
    const { t } = useTranslation();
    

    //Parametros de entrada.
    const inputParam_MessageObjId = props.messageObjectId !== null && props.messageObjectId !== undefined ? props.messageObjectId : null;
    const inputParam_MessageObjStatusId = props.messageObjectStatusId !== null && props.messageObjectStatusId !== undefined ? props.messageObjectStatusId : null;
    const inputParam_CurrentUserName = props.currentUserName !== null && props.currentUserName !== undefined ? props.currentUserName : null;
    const inputParam_SectionPartyMemberId = props.sectionPartyMemberId !== null && props.sectionPartyMemberId !== undefined ? props.sectionPartyMemberId : "#NA#";
    

    const inputParam_SetterFireUpdateBoxListControl = props.setterFireUpdateBoxListControl !== null && props.setterFireUpdateBoxListControl !== undefined ? props.setterFireUpdateBoxListControl : false;
    const inputParam_IsPanelOpen = props.isPanelOpen;
    const inputParam_SetterIsPanelOpen = props.setterIsPanelOpen;

    //Parametros de componente.
    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    
    const [successful, setSuccessful] = useState(null);
    const [message, setMessage] = useState(null);
    const [messageType, setMessageType] = useState(null);
    const [showMessage, setShowMessage] = useState(false);

    const [txtMessageEventDescIsInvalid, setTxtMessageEventDescIsInvalid] = useState(false)

    const [objMessageEvent, setMessageEvent] = useState({
        id: 0,//Se envia en 0, 0 es null para API.
        messageId: inputParam_MessageObjId !== null ? inputParam_MessageObjId : 0,
        sectionPartyMemberId: null,//Averiguar de donde obtener.
        messageEventNemo: null,//Se autocalcula en API.
        messageEventDate: null,//Fecha del evento a crear
        messageEventUsername: inputParam_CurrentUserName,//Deberia ser automatico segun el usuario conectado
        messageEventName: "",//Agregar como campo.
        messageEventDesc: null,//Agregar como campo.
        messageStatusId: inputParam_MessageObjStatusId !== null ? inputParam_MessageObjStatusId : 0,
        messageEventTypeId: null,
    });

    //Funciones de componente.
    const setEventDescValue = (e) => {
        const { value } = e.currentTarget; // <-- moved outside asynchronous context

        setMessageEvent(prevState => ({
            ...prevState,
            messageEventDesc: value
        }));
        setMessageEvent(prevState => ({
            ...prevState,
            messageId: inputParam_MessageObjId !== null ? inputParam_MessageObjId : 0
        }));
        setMessageEvent(prevState => ({
            ...prevState,
            messageStatusId: inputParam_MessageObjStatusId !== null ? inputParam_MessageObjStatusId : 0
        }));
        setMessageEvent(prevState => ({
            ...prevState,
            sectionPartyMemberId: inputParam_SectionPartyMemberId
        }));
    }
    const validateForm = (obj) => {
        const validDesc = obj.messageEventDesc !== "" && obj.messageEventDesc !== null;

        setTxtMessageEventDescIsInvalid(!validDesc);

        return validDesc;
    };
    //Eventos de componente.

    const onSaveMessageEvent = () => {
        let formIsValid = validateForm(objMessageEvent);

        if (formIsValid === true) {
            objMessageEvent.messageEventDate = new Date();
            objMessageEvent.messageEventNemo = "";
            
            
            //Guardar elemento libro.
            saveMessageComment(objMessageEvent).then(() => {
                setShowMessage(true)
                setSuccessful(true);
                setMessageType("success");
                setMessage(t('data-lang-msg-operationperformed'))
                inputParam_SetterFireUpdateBoxListControl(true);

                onDismissPanel();
            }).catch(() => {
                setShowMessage(true)
                setSuccessful(false);
                setMessageType("error");
                setMessage(t('data-lang-msg-operationerror'))
            });
        } else {
            //Alertar que algo interrumpe la creacion del libro.
            setShowMessage(true)
            setSuccessful(false);
            setMessageType("warning");
            setMessage(t('data-lang-msg-requireddatanotset'))
        }
    };

    const onClosePanel = () => {
        onDismissPanel();
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        setMessageEvent({
            id: 0,
            messageId: inputParam_MessageObjId !== null ? inputParam_MessageObjId : 0,
            sectionPartyMemberId: null,
            messageEventNemo: null,
            messageEventDate: null,
            messageEventUsername: inputParam_CurrentUserName,
            messageEventName: "",
            messageEventDesc: null,
            messageStatusId: inputParam_MessageObjStatusId !== null ? inputParam_MessageObjStatusId : 0,
            messageEventTypeId: null,
        })
        setShowMessage(false)
        setTxtMessageEventDescIsInvalid(false)
        inputParam_SetterIsPanelOpen(false);

    };

    const onRenderFooterContent = () => {
        return <div>
            <PrimaryButton onClick={ onSaveMessageEvent } styles={_global_buttonStyles}>{ t('data-lang-btn-save') }</PrimaryButton>
            <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
        </div>
    };

    //Render de componente.
    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isOnRightSide={false}
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-lbl-neweventcomment') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ undefined }
                className="left-panel"
                type={ PanelType.customNear }
            >
                <Row className="pt-3">
                    <Col xl={12}>
                        <CTextAreaSimple
                            labelText={ t('data-lang-lbl-body') }
                            editMode={true}
                            setterControlValue={ setEventDescValue }
                            controlValue={ objMessageEvent.messageEventDesc }
                            isInvalirControl={ txtMessageEventDescIsInvalid }
                        />
                    </Col>
                </Row>
                <Row style={{height: "100px"}} className="pt-3">
                    <Col className="message-verybottom-panel-medium">
                        <Message width="96%" message={ message } display={ successful === null? false : showMessage } messageType={ messageType } setterShowMessage={ setShowMessage } />
                    </Col>
                </Row>
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
}

export default SidePanelNewCommentEvent;